export default {
  allExportBatches: state => state.exportBatches,
  exportBatchesLoading: state => state.loading
}
